import { format, parse } from 'date-fns';

const getOrdinalSuffix = (day: number): string => {
	if (day >= 11 && day <= 13) {
		return 'th';
	}
	switch (day % 10) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};

export const formatDateWithOrdinalSuffix = (dateString: string): string => {
	const date = parse(dateString, 'MMMM d, yyyy', new Date());

	const month = format(date, 'MMMM');

	const day = format(date, 'd');
	const dayNumber = parseInt(day, 10);
	const ordinalSuffix = getOrdinalSuffix(dayNumber);

	return `${month} ${day}${ordinalSuffix}`;
};
